import { render, staticRenderFns } from "./LeaderBoardTable.vue?vue&type=template&id=05167f6e&scoped=true&"
import script from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardTable.vue?vue&type=style&index=0&id=05167f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05167f6e",
  null
  
)

export default component.exports